import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import { Share2 } from "lucide-react";
import {
  pickRandomShareButtonLabel,
  SHARE_BUTTON_LABEL_SIZER,
} from "./shareReminders";

const shareShine = keyframes`
  0% { background-position: -200% center; }
  100% { background-position: 200% center; }
`;

const StyledShareButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-sizing: border-box;
  width: ${(props) => (props.$compact ? "min(260px, 80%)" : "min(360px, 90%)")};
  min-height: ${(props) => (props.$compact ? "48px" : "58px")};
  margin: 0 auto 12px;
  padding: ${(props) => (props.$compact ? "0.5rem 1rem" : "0.7rem 1.2rem")};
  border: 0;
  border-radius: 16px;
  font-family: "Quicksand", sans-serif;
  font-weight: bold;
  font-size: ${(props) => (props.$compact ? "0.78rem" : "0.85rem")};
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #4a3600;
  cursor: pointer;
  background: linear-gradient(135deg, #ffd700 0%, #fff6a8 50%, #ffd700 100%);
  background-size: 200% auto;
  animation: ${shareShine} 3s linear infinite;
  box-shadow: 0 4px 0 #b8860b, 0 4px 16px rgba(255, 215, 0, 0.45);

  &:hover {
    background: linear-gradient(135deg, #ffe44d 0%, #fffbe0 50%, #ffe44d 100%);
    background-size: 200% auto;
    box-shadow: 0 4px 0 #b8860b, 0 6px 20px rgba(255, 215, 0, 0.6);
  }

  &:active:not(:disabled) {
    transform: translateY(4px);
    box-shadow: none;
  }

  &:disabled {
    opacity: 0.7;
    cursor: wait;
  }
`;

const ShareLabel = styled.span`
  display: inline-grid;
  justify-items: center;
  align-items: center;
  text-align: center;
  line-height: 1.15;

  > span {
    grid-area: 1 / 1;
  }

  > span:first-child {
    visibility: hidden;
    white-space: nowrap;
    pointer-events: none;
  }
`;

export default function CertificateShareButton({
  onClick,
  disabled,
  compact = false,
  ariaLabel = "Share this certificate",
}) {
  const [label] = useState(pickRandomShareButtonLabel);

  return (
    <StyledShareButton
      type="button"
      aria-label={ariaLabel}
      onClick={onClick}
      disabled={disabled}
      $compact={compact}
    >
      <Share2 size={compact ? 16 : 18} strokeWidth={2.5} />
      <ShareLabel>
        <span aria-hidden="true">{SHARE_BUTTON_LABEL_SIZER}</span>
        <span>{label}</span>
      </ShareLabel>
    </StyledShareButton>
  );
}
